<template>
  <div class="home">
    <div class="breadth banner">
      <div class="banner-box">
        <div class="banner-left">
          <div class="banner-left-top">
            <p class="banner-left-text">BUILD Your Dream Finance</p>
            <p class="banner-left-content"><span>Gateway to Stocks</span></p>
          </div>
          <div v-if="!isLogin" class="banner-left-bottom">
            <div class="banner-item">
              <img class="banner-img1" src="@/assets/images/home/banner-1.svg" alt="">
              <div class="banner-item-one">
                <p class="banner-item-text">2020</p>
                <p class="banner-item-content box-content">Founded in</p>
              </div>
            </div>
            <div class="banner-item">
              <img class="banner-img2" src="@/assets/images/home/banner-2.webp" alt="">
              <div class="banner-item-one">
                <p class="banner-item-text">More Than 1,000,000</p>
                <p class="banner-item-content box-content">Worldwide Users</p>
              </div>
            </div>
          </div>
          <div v-if="isLogin" class="banner-left-open">
            <div class="banner-left-btn" @click="goRoute('/futures')">Trade now</div>
          </div>
        </div>
        <div class="banner-right">
          <video class="video" src="@/assets/video/banner-video.mp4" loop muted autoplay>
          </video>
        </div>
        <div class="banner-bottom">
          <img src="@/assets/images/home/banner-3.svg" alt="">
          <!-- 消息公告 -->
          <div class="scroll-container">
            <div class="scroll-text">
              {{ tips }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--    <div class="breadth">-->
    <!--      <div class="swiper">-->
    <!--        <el-carousel>-->
    <!--          <el-carousel-item v-for="item in bannerList" style="width: 100%; height: 100%;">-->
    <!--            <img :src="item.imgurl">-->
    <!--          </el-carousel-item>-->
    <!--        </el-carousel>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="breadth coinType">
      <!-- 👇 核心：左右两栏布局 -->
      <div class="coinType-box">
        <!-- 左侧：表格 -->
        <div class="coinType-box-left">
          <!-- 顶部标签 -->
          <div class="coinType-list">
            <div v-for="(item, index) in tabList" :key="index" class="coinType-list-item"
                 :class="{ active: activeTab === index }" @click="goActiveTab(index)">
              {{ item.name }}
            </div>
          </div>
          <div class="coinType-table">
            <el-table v-loading="Tableloading" empty-text="No data available." :data="coinList"
                      class="coinType-table-item">
              <el-table-column label="Pair" prop="Pair">
                <template slot-scope="scope">
                  <!-- 左边图片 + 右边价格 并排 -->
                  <div style="display: flex; align-items: center; gap:15px;">
                    <!-- 你的图片 -->
                    <img :src="coinImg['xxx']" v-if="scope.row.t == 2 || scope.row.t == 3 || scope.row.t == 5">
                    <img :src="coinImg[scope.row.i]" v-else>
                    <!-- 价格 -->
                    <span>{{ scope.row.n }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column sortable label="Price" prop="p"/>
              <el-table-column sortable label="Change">
                <template slot-scope="scope">
                  <span :class="scope.row.zf <= 0 ? 'green' : 'red'">
                    {{ scope.row.zf > 0 ? '+' : '' }}{{ scope.row.zf }}%
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Action">
                <template slot-scope="scope">
                  <el-button @click="goTrade(scope.row)" type="text" class="trade-btn1">{{ $t('Trade') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="breadth download">
      <div class="download-box">
        <div class="download-box-left box-title">
          <p class="download-box-left-text">Trade Anywhere</p>
          <p class="download-box-left-content box-content">Vanguard | One-Stop Digital Asset Trading Platform
          </p>
        </div>
        <div class="download-box-right">
          <img src="@/assets/images/home/download-1.png" alt="">
        </div>
      </div>
    </div>

    <div class="marquee-block">
      <HorizontalScroll :data-list="BrandList" :speed="2">
        <template #default="{ data }">
          <div class="marquee-item item">
            <img class="marquee-image" :src="data.image" alt/>
          </div>
        </template>
      </HorizontalScroll>
    </div>
  </div>
</template>

<script scoped>
import {gundong, index} from "@/api";
import {exchange, contract, stock, forex, fund} from "@/api/market";
import {coinArr} from "@/utils/coin";
import {wsUrl} from "@/utils/env";
import Socket from '@/utils/socket'
import HorizontalScroll from '@/components/scroll.vue';

export default {
  components: {
    HorizontalScroll
  },
  data() {
    return {
      activeTab: 0, // 默认选中第一个
      activeIndex: 0, // 默认没有变大的盒子
      FaqBtn: false,
      FaqActive: ' ',
      Tableloading: false,
      CardList: [],  // card内容
      TrustList: [],    //TrustList内容
      brandlen: 0,
      // 顶部切换标签
      tabList: [
        {name: this.$t('coin.stocks'), id: 3},
        {name: this.$t('coin.spot'), id: 1},
        {name: this.$t('coin.futures'), id: 2},
        {name: this.$t('coin.forex'), id: 4},
        {name: this.$t('coin.funds'), id: 5},
      ],
      TableaList: [],
      TableaList1: [],
      TableaList2: [],
      BrandList: [
        {image: require("@/assets/brand/logo1.webp")},
        {image: require("@/assets/brand/logo2.webp")},
        {image: require("@/assets/brand/logo3.webp")},
        {image: require("@/assets/brand/logo4.webp")},
        {image: require("@/assets/brand/logo5.webp")},
        {image: require("@/assets/brand/logo6.webp")},
        {image: require("@/assets/brand/logo7.webp")},
        {image: require("@/assets/brand/logo8.webp")},
      ],
      settings: {
        infinite: true,          // 开启无缝无限循环（首尾衔接环绕）
        slidesToShow: 8,        // 视图区域同时展示 10 个轮播项
        slidesToScroll: 1,       // 每次滚动切换 1 个项（匀速跑马灯必须设1）
        autoplay: true,          // 是否自动播放
        autoplaySpeed: 0,        // 自动播放间隔时间(ms)，设0实现连续不停顿滚动
        speed: 3000,             // 单次滚动动画时长 3000毫秒(越大约越慢)
        cssEase: "linear",       // 动画匀速运动（无加速减速，纯平滑移动）
        arrows: false,           // 隐藏左右切换箭头
        dots: false,             // 隐藏底部小圆点指示器
        accessibility: false,    // 关闭无障碍读写，解决 aria-hidden 控制台警告
        focusOnSelect: false,    // 禁止点击项自动聚焦，消除焦点报错
        variableWidth: false,    // 关闭不等宽模式，统一均分宽度，防止布局错乱
        centerMode: false,       // 关闭居中模式，避免两侧裁切、只显示一半内容
      },
      tips: '',
      coinList: [],
      keyList: [],
      coinImg: coinArr,
      keys: '',
      wsStr: 'stock',
      wsUrl,
      bannerList: []
    }
  },
  created() {
    this.getIndex()
    this.getGong()
    this.getStock()
    this.initWs()
  },
  methods: {
    initWs() {
      const ws = new Socket(wsUrl)
      ws.on('open', () => {
        this.ws = ws
        this.ws.send({cmd: this.wsStr, data: ''})
      })
      ws.on('message', res => {
        if (res.cmd == 'pong') {
          this.ws.send({cmd: 'ping', data: ''})
        } else if (res.cmd == 'exchange') {
          if (this.activeTab == 1 && !this.keys) {
            this.coinList = res.data
            this.keyList = res.data
          }
        } else if (res.cmd == 'contract') {
          if (this.activeTab == 2 && !this.keys) {
            this.coinList = res.data
            this.keyList = res.data
          }
        } else if (res.cmd == 'stock') {
          if (this.activeTab == 0 && !this.keys) {
            var wsList = []
            res.data.forEach((item) => {
              if (item.show == 1) {
                wsList.push(item)
              }
            })
            this.coinList = wsList
            this.keyList = wsList
          }
        } else if (res.cmd == 'forex') {
          if (this.activeTab == 3 && !this.keys) {
            this.coinList = res.data
            this.keyList = res.data
          }
        } else if (res.cmd == 'fund') {
          if (this.activeTab == 4 && !this.keys) {
            this.coinList = res.data
            this.keyList = res.data
          }
        }
      })
    },
    closeWs() {
      this.ws.send({cmd: 'unsub', data: ''})
      this.ws.doClose()
    },
    getExchange() {
      exchange().then(res => {
        this.coinList = res
        this.keyList = res
      })
    },
    getContract() {
      contract().then(res => {
        this.coinList = res
        this.keyList = res
      })
    },
    getStock() {
      stock().then(res => {
        this.coinList = res
        this.keyList = res
      })
    },
    getForex() {
      forex().then(res => {
        this.coinList = res
        this.keyList = res
      })
    },
    getFund() {
      fund().then(res => {
        this.coinList = res
        this.keyList = res
      })
    },
    getIndex() {
      index().then(res => {
        this.bannerList = res.banner
      })
    },
    getGong() {
      gundong().then(res => {
        this.tips = res
      })
    },
    goRoute(path) {
      this.$router.push(path);
    },
    pause() {
      const carousel = this.$refs.carousel;
      if (carousel && carousel.$el) {
        const slider = carousel.$el.querySelector(".slick-slider");
        if (slider) $(slider).slick("slickPause");
      }
    },
    play() {
      const carousel = this.$refs.carousel;
      if (carousel && carousel.$el) {
        const slider = carousel.$el.querySelector(".slick-slider");
        if (slider) $(slider).slick("slickPlay");
      }
    },
    goActiveTab(index) {
      this.activeTab = index
      this.changeType(index)
    },
    changeType(key) {
      this.coinList = []
      this.keyList = []
      this.closeWs()
      if (key == 0) {
        this.getStock()
        this.wsStr = 'stock'
      } else if (key == 1) {
        this.getExchange()
        this.wsStr = 'exchange'
      } else if (key == 2) {
        this.getContract()
        this.wsStr = 'contract'
      } else if (key == 3) {
        this.getForex()
        this.wsStr = 'forex'
      } else if (key == 4) {
        this.getFund()
        this.wsStr = 'forex'
      }
      this.initWs()
    },
    goTrade(item) {
      if (this.activeTab == 0) {
        this.$router.push("/stock?name=" + item.n + "&type=" + item.t)
      } else if (this.activeTab == 1) {
        this.$router.push("/spot?name=" + item.n + "&type=" + item.t)
      } else if (this.activeTab == 2) {
        this.$router.push("/futures?name=" + item.n + "&type=" + item.t)
      } else if (this.activeTab == 3) {
        this.$router.push("/forex?name=" + item.n + "&type=" + item.t)
      } else if (this.activeTab == 4) {
        this.$router.push("/fund?name=" + item.n + "&type=" + item.t)
      }
    },
  },
  mounted() {

  },
  computed: {
    // 获取当前 i18n 语言
    isLogin() {
      // 取本地存储的token，有值就是已登录
      return !!localStorage.getItem('token')
    }
  },
}
</script>

<style scoped lang="less">
.home {
  box-sizing: border-box;
  margin-top: 65px;
  min-height: calc(100vh-65px);
  min-width: 1248px;
  background-color: #000;
  padding-bottom: 40px;
}

.breadth {
  width: 1260px;
  margin: 0 auto;
}

.box-title {
  color: #e3e4e5 !important;
}

.box-content {
  color: #9b9b9e !important;
}

.banner {
  color: #fff;
  margin: 0 auto;
  height: 504px;
}

.banner .banner-box {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;
}

.banner .banner-box .banner-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 1 !important;
  margin-top: -50px;
  height: 100%;
}

.banner .banner-box .banner-left .banner-left-top {
  padding-bottom: 24px;
}

.banner .banner-box .banner-left .banner-left-top .banner-left-text {
  font-size: 50px !important;
  font-weight: 800;
  margin-bottom: 12px;
}

.banner .banner-box .banner-left .banner-left-top .banner-left-content {
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
}

.banner .banner-box .banner-left .banner-left-top .banner-left-content span {
  margin-bottom: 12px;
  font-size: 16px !important;
  font-weight: 600;
  margin-left: 3px;
  color: #8ddf29;
}

.banner .banner-box .banner-left .banner-left-bottom {
  display: flex;
  align-items: center;
}

.banner .banner-box .banner-left .banner-left-bottom .banner-item {
  display: flex;
  align-items: center;
}

.banner .banner-box .banner-left .banner-left-bottom .banner-img1 {
  width: 40px;
  height: 40px;
}

.banner .banner-box .banner-left .banner-left-bottom .banner-img2 {
  margin-left: 20px;
  width: 92px;
  height: 40px;
}

.banner .banner-box .banner-left .banner-left-bottom .banner-item .banner-item-one {
  margin-left: 4px;
}

.banner .banner-box .banner-left .banner-left-bottom .banner-item .banner-item-text {
  font-size: 16px;
  font-weight: 600;
}

.banner .banner-box .banner-left .banner-left-bottom .banner-item .banner-item-content {
  font-size: 10px;
}

.banner-left-open {
  width: 100%;
  display: flex;
  gap: 6px;
}

.banner-left-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 15px;
  height: 40px;
  background-color: #1f2326;
}

.banner-left-btn:first-child {
  margin-left: 0px;
  background-color: #8ddf29 !important;
}

.banner-left-btn:last-child {
  background: linear-gradient(135deg, gold, #ff8c00) !important;
}

.banner-left-btn {
  margin-left: 20px;
}

.banner .banner-box .banner-right {
  display: flex;
  justify-content: flex-start;
  flex: 2 !important;
  height: 100%;
}

.video {
  width: auto;
  object-fit: cover;
  /* 不变形、铺满 */
  z-index: 0;
  height: 350px;
}

.banner .banner-bottom {
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  display: flex;
  bottom: 0;
  justify-content: space-between;
  align-items: center;
}

.banner .banner-bottom img {
  width: 24px;
  height: 24px;
}

.banner .banner-bottom .banner-bottom-text {
  color: #8ddf29;
  cursor: pointer;
  width: 70px;
}

/* 顶部标签 */
.coinType-list {
  display: flex;
  margin-bottom: 15px;
}

.coinType-list .coinType-list-item {
  padding: 0px 15px;
  color: #9b9b9e;
  cursor: pointer;
  font-size: 20px;
  font-weight: 700;
}

.coinType-list-item:first-child {
  padding-left: 0px;
}

.coinType-list-item.active {
  color: #fff;
  font-weight: 700;
}

/* 👇 左右布局核心 */
.coinType-box {
  width: 100%;
  display: flex;
  gap: 20px;
  height: 100%;
}

.coinType .coinType-box .coinType-box-left {
  flex: 3;
  background-color: #15181a;
  padding: 15px;
  border-radius: 10px;
  height: auto;
}

.coinType .coinType-box .coinType-box-right {
  flex: 2;
  background-color: #15181a;
  padding: 15px;
  border-radius: 10px;
  height: auto;
  margin: 0px;
}

/* 右侧面板 */
.right-box {
  height: auto;
  box-sizing: border-box;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #333;
}

.price {
  font-size: 18px;
  font-weight: bold;
}

.full-btn {
  margin-top: 20px;
  background: #409eff;
  border: none;
}

/* 深色表格 */
::v-deep .coinType-table-item {
  color: #fff;
  border: 0 !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

::v-deep .coinType-table-item img {
  width: 26px;
  height: 26px;
  border-radius: 13px;
}

::v-deep .el-table th {
  color: #909399;
  background: #15181a !important;
  border: 0 !important;

}


::v-deep.el-table .cell {
  overflow: visible !important;
}

::v-deep .el-table__row,
::v-deep .el-table td {
  background: #15181a !important;
  color: #e3e4e5 !important;
  border: 0 !important;
  padding: 12px 0px !important;
}


::v-deep el-table__row {
  padding: 12px 0px !important;
}

::v-deep .el-table::before {
  display: none !important;
}

.green {
  color: #25a750;
  font-weight: 700;
}

.red {
  color: #ca3f64;
  font-weight: 700;
}

.trade-btn {
  height: 30px;
  background: #222;
  color: #fff;
  border-radius: 4px;
  padding: 2px 10px;
  width: 80px;
}

.trade-btn:hover {
  transition: background-color 0.25s ease;
  height: 30px;
  background: #8ddf29;
  color: #fff;
  border-radius: 4px;
  padding: 2px 10px;
  width: 80px;
}

::v-deep .el-table__empty-block {
  background-color: #15181a;
  height: auto;
}

::v-deep .el-button--text:active {
  transition: background-color 0.25s ease;
  color: #fff !important;
}

// 11

.container {
  height: 303px;
  margin: 16px auto 0px;
}

.container .container-box {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.container .container-box .container-item {
  box-sizing: border-box;
  flex: 1;
  border-radius: 10px;
  cursor: pointer;
  font-size: 24px;
  text-align: center;
  height: 234px;
  background: #15181a;
  display: flex;
  border: 1px solid transparent;
  transition: border-color .3s;
}

.container .container-box .container-item:hover {
  border: 1px solid green;
}

.container .container-box .container-item .container-item-left {
  box-sizing: border-box;
  padding: 20px;
  flex: 2;
}

.container .container-box .container-item .container-item-left .container-item-left-content {
  height: 30px;
  text-align: left;
}

.container .container-box .container-item .container-item-left .container-item-left-text {
  font-size: 30px;
  height: 90px;
  line-height: 35px;
  margin-top: 30px;
  text-align: left;
}

.container .container-box .container-item .container-item-left .container-item-left-btn {
  display: flex;
  justify-content: flex-start;
  border: none;

}

.container .container-box .container-item .container-item-left .container-item-left-btn .title {
  color: #fff;
  padding: 4px 15px;
  background: #8ddf29;
  border-radius: 4px;
}

.container .container-box .container-item .container-item-right {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 35px;
  flex: 1;
}

.container .container-box .container-item .container-item-right img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.coinType {
  display: flex;
  align-items: stretch;
  border-radius: 10px;
  flex: 1;
  margin-top: 50px;
}

::v-deep .el-loading-mask {
  background-color: #15181a;
}

// 11


.download {
  margin-top: 36px;
  background: transparent;
}

.download .download-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 208px;
  background-color: #0f1112;
}

.download .download-box .download-box-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100px;
  flex: 1.5;
  margin-top: -40px;
  margin-left: 50px;
}

.download .download-box .download-box-left-text {
  font-size: 48px;
  font-weight: 700;
  margin-left: 50px;
}

.download .download-box .download-box-left-content {
  font-size: 20px;
  margin-top: 10px;
  font-weight: 700;
}

.download .download-box .download-box-right {
  flex: 2;
  display: flex;
  justify-content: flex-end;
}

.download .download-box .download-box-right img {
  width: 90%;
}

.trust {
  margin-top: -40px;
  height: 280px;
}

.trust .trust-box {
  box-sizing: border-box;
}

.trust .trust-box .trust-box-wz {
  margin-bottom: 20px;
}

.trust .trust-box .trust-box-wz .trust-box-wz-text {
  font-size: 40px;
}

.trust .trust-box .trust-box-wz .trust-box-wz-content {
  font-size: 20px;
}

.trust .trust-box .trust-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.trust .trust-box .trust-card .trust-card-item {
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #15181a;
  flex: 2 1 0;
  height: 300px !important;
}

.trust .trust-box .trust-card .trust-card-item.active {
  box-sizing: border-box;
  align-items: flex-start;
  flex: 3 1 0;
}

.trust .trust-box .trust-card .trust-card-item .trust-item-wz {
  height: 200px !important;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.trust .trust-box .trust-card .trust-card-item .trust-item-wz .trust-item-wz-text {
  font-size: 32px;
  color: #fff;
  margin: 15px 20px;
  font-weight: 400;
}

.trust .trust-box .trust-card .trust-card-item .trust-item-wz .trust-item-wz-content {
  margin: 15px 20px;
}

.trust .trust-box .trust-card .trust-card-item .trust-item-img {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 160px;
}

.trust .trust-box .trust-card .trust-card-item .trust-item-img.active {
  justify-content: flex-start;
}

.trust .trust-box .trust-card .trust-card-item img {
  width: 160px;
  height: auto;
}

.trust .trust-box .trust-card .trust-card-item img.active {
  margin-bottom: 20px;
  margin-left: 20px;
}

.marquee {
  padding: 50px;
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
}

.marquee-item {
  width: 170px !important;
  margin: 6px;
  padding: 5px;
  text-align: center;
  box-sizing: border-box;
  background-color: #15181a;
}

.marquee .marquee-item .marquee-image {
  height: 42px;
}

/* 强制修复插件样式，不横屏拉长 */
::v-deep .slick-list {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  margin-top: 30px !important;
}

::v-deep .slick-slider {
  width: 100% !important;
}

.faq {
  margin-top: 10px;
}

.faq .faq-box {
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.faq .faq-box .faq-top .faq-top-wz {
  font-size: 40px;
}

.faq .faq-item {
  display: flex;
  justify-content: space-between;
}

.faq .faq-item .faq-item-left .faq-item-left-content-text {
  font-size: 15px;
}

.faq .faq-item .faq-item-left .faq-item-left-text {
  display: flex;
  align-items: center;
}


.faq .faq-item .faq-item-left .faq-item-left-content {
  font-size: 20px;
  font-weight: 700;
}

.faq .faq-item .faq-item-left .faq-item-left-orderly {
  background-color: #15181a;
  border-radius: 2px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  width: 30px;
  margin-right: 20px;
}

.faq .faq-item .faq-item-right {
  font-size: 30px !important;
}

.faq .faq-item .faq-item-right1 {
  color: #8DDF29 !important;
}

.notic {
  margin: 0 10px;
  line-height: 30px;
  width: 100%;
}

.swiper {
  margin: 20px 0;

  img {
    width: 100%;
    height: 100%;
    // object-fit: contain;
  }
}

.notice-wrap {
  background: rgba(255, 144, 63, 1);
}

.item {
  padding: 8px 16px;
  border-radius: 6px;
  white-space: nowrap;
  cursor: pointer;
}

.marquee-block {
  margin: 50px auto 20px;
  width: calc(100vw - 30px);
  box-sizing: border-box;
}

.scroll-container {
  width: 100%;
  /* 或者具体的宽度 */
  overflow: hidden;
  white-space: nowrap;
  /* 防止文本换行 */
  position: relative;
  height: 30px;
  line-height: 30px;
}

.scroll-text {
  position: absolute;
  white-space: nowrap;
  padding: 0 10px;
  /* 防止文本换行 */
  animation: scrollText 30s linear infinite;
  /* 持续时间、动画效果、重复 */
  height: 30px;
  line-height: 30px;
}

@keyframes scrollText {
  0% {
    transform: translateX(100%);
    /* 开始时向右移动 */
  }

  100% {
    transform: translateX(-100%);
    /* 结束时向左移动 */
  }
}
</style>
